import axios from "axios";

import { SERVER_URL } from "../config/index";

const request = axios.create({
  baseURL: SERVER_URL,
  timeout: 100000,
});

export default request;
